import React, { useCallback, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, EmailNodeIcon, IconCAPNode, IconMobileNode, PDFNodeIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";
import { CapNodePropsTypes, MobileNodePropsTypes } from "./FlowchartTypes";

const CAPNode: React.FC<CapNodePropsTypes> = ({ id, data }) => {
    
    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };

    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    return (
        <div className={`cap-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <IconCAPNode width='2rem'/>
            <span>{data.label}</span>
            {isHovering && (
                <div className={`node-close-ico`} onClick={deleteNode}>
                    <CloseIcon width='1rem' color="var(--color-main-red)"/>
                </div>
            )}  
            <Handle id='pdf-target-a' type='target' position={Position.Top} style={{...targetCustomStyles, background: "blue"}}/>
            {/* <Handle id='pdf-source-a' type='source' position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/> */}
        </div>
    );
};

export default CAPNode;
